var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-rblock",staticStyle:{"background-color":"#fff"}},[_vm._v(_vm._s(_vm.$t(_vm.data.title || _vm.data.label)))])}
var staticRenderFns = []

export { render, staticRenderFns }